/**
 * useRKHDetail Hook
 * Custom hook for fetching and managing RKH detail data
 */

import { useState, useCallback } from 'react';
import rkhApiService from '../services/rkhApiService';
import { RKHDetail } from '../types';

interface UseRKHDetailResult {
    data: RKHDetail | null;
    loading: boolean;
    error: string | null;
    fetchDetail: (id: string) => Promise<void>;
    clearDetail: () => void;
}

export const useRKHDetail = (): UseRKHDetailResult => {
    const [data, setData] = useState<RKHDetail | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchDetail = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);

        try {
            const response = await rkhApiService.getRKHDetail(id);
            setData(response.data);
        } catch (err: any) {
            const errorMessage = err.response?.data?.error || 
                               err.response?.data?.detail || 
                               err.message || 
                               'Gagal memuat detail RKH';
            setError(errorMessage);
            setData(null);
        } finally {
            setLoading(false);
        }
    }, []);

    const clearDetail = useCallback(() => {
        setData(null);
        setError(null);
    }, []);

    return {
        data,
        loading,
        error,
        fetchDetail,
        clearDetail,
    };
};

export default useRKHDetail;
